import React from 'react';
import Skill from './Skill';
const SkillContainer = ({ languages, children }) => {
    return (
        <section className='pb-5 border-b-[1px] border-gray-800' data-aos="fade" data-aos-duration="1000">
            <h2 className='text-green-600 py-1 lg:py-2 text-xl lg:text-2xl font-play font-bold capitalize  border-b-[1px] border-gray-800'>{children}</h2>
            <div className='flex justify-center'>
                <div className='grid xs:grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 xl:grid-cols-7 2xl:grid-cols-9 gap-0'>
                    {languages.map((language, index) => <Skill key={index} language={language} ></Skill>)}
                </div>
            </div>
        </section>
    );
};
export default SkillContainer;